/* ============
 * MessageTemplateType Transformer
 * ============
 *
 * The transformer for the messageTemplateType.
 */

import Transformer from './transformer';

export default class MessageTemplateTypeTransformer extends Transformer {
  static fetch(messageTemplateType) {
    return {
      id: messageTemplateType.id,
      name: messageTemplateType.name,
    };
  }

  static send(messageTemplateType) {
    return {
      id: messageTemplateType.id,
      name: messageTemplateType.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/messageTemplateType.js